const prefix = 'Auth:'

export const AUTH_COOKIE_NAME = 'session_secure'

export const SET_API_KEY = `${prefix} Set values for the api key.`
export const SET_SPID_KEY = `${prefix} Set values for the spid login.`
export const SET_BEARER_TOKEN = `${prefix} Set the bearer token for a auth source.`
export const SET_LOGGED_IN = `${prefix} Set if the user is logged in or not.`
export const LOGOUT = `${prefix} logout from spid.`
export const HAS_LOGIN_ERROR = `${prefix} Set if the user has some kind of a loginError`
export const SHOW_LOGIN_TO_CONTINUE = `${prefix} show login to continue promt`
export const CLOSE_LOGIN_TO_CONTINUE = `${prefix} close login to continue promt`
